import { Button } from '@mui/material';
import { styled } from '@mui/material/styles';

const ActionButton = styled(Button)(({ theme }) => ({
    height: 50, minWidth: 160, margin: '20px auto', paddingLeft: 25, paddingRight: 25, borderRadius: 50, background: '#FFF', color: '#7769c4',
    '&:hover, &.active': { background: 'rgba(0,0,0,.4)', color: '#FFF' },
}));

export default ActionButton;